import type { DocumentPickerOptions } from 'expo-document-picker';
import { getDocumentAsync } from 'expo-document-picker';
import type { ImagePickerOptions, ImagePickerResult } from 'expo-image-picker';
import {
  getCameraPermissionsAsync,
  launchCameraAsync,
  launchImageLibraryAsync,
  requestCameraPermissionsAsync
} from 'expo-image-picker';

import type { ImagePickType } from '@/features/media/types/picker';
import { hasItems } from '@/shared/utils/array';
import { isAndroid } from '@/shared/utils/platform';

export const pickImages = async (
  pick: ImagePickType,
  options?: ImagePickerOptions
) => {
  try {
    let result: ImagePickerResult;

    if (pick === 'select') {
      result = await launchImageLibraryAsync({
        // Todo: check if transparent nav bar issue is fixed on android. If so then enabled editing on android again
        allowsEditing: false,
        base64: true,
        quality: 1,
        ...options
      });
    } else {
      // Todo: seems like this is only needed on iOS but the code is not causing any issues on android (and may be even helpful if there is no permission granted)
      const { granted } = await getCameraPermissionsAsync();
      if (!granted) await requestCameraPermissionsAsync();
      result = await launchCameraAsync({
        allowsEditing: isAndroid,
        base64: true,
        quality: 1,
        ...options
      });
    }

    if (!result.canceled && hasItems(result.assets)) {
      return result.assets;
    }
  } catch (error) {
    console.error('[PICK_IMAGES]: picking images failed:', error);
  }
};

export const pickDocuments = async (options: DocumentPickerOptions) => {
  try {
    // No permissions request is necessary for launching the document library
    const result = await getDocumentAsync(options);

    if (!result.canceled && hasItems(result.assets)) {
      return result.assets;
    }
  } catch (error) {
    console.error('[PICK_DOCUMENTS]: picking documents failed:', error);
  }
};
